import axios from 'axios';

import cfac22 from '../cfac22';

export default function readEstablishment(establishmentId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      get(`${cfac22('API_HOST_V2')}/establishments/${establishmentId}`, {
        headers: { 'Full-Url': window.location.href }, withCredentials: true
      }).
      then((result) => {
        resolve(result.data.establishmentInfo);
      }).
      catch((error) => {
        reject(error);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
